
import { SimulationConfig, EscapeRing } from '@/types';
import { random } from '@/lib/random';

export class EscapeService {
  public static generateRings(config: SimulationConfig): EscapeRing[] {
    const rings: EscapeRing[] = [];
    const baseAngle = (config.escapeFixedGapDirection * Math.PI / 180);
    const oppositeCount = (config.escapeOppositeGapCount || 0);

    for (let i = 0; i < config.escapeRingCount; i++) {
        let angle = baseAngle;
        let isOpposite = i < oppositeCount;
        
        // Base Alignment Logic
        if (config.escapeGapAlignment === 'RANDOM') {
            angle = random.next() * Math.PI * 2;
            // Opposite logic doesn't apply well to random, but we can flip it if requested
            if (isOpposite) angle = (angle + Math.PI) % (Math.PI * 2);
        }
        else if (config.escapeGapAlignment === 'SPIRAL') {
            angle = baseAngle + i * (config.escapeSpiralTightness || 0.15);
            if (isOpposite) angle += Math.PI;
        }
        else if (config.escapeGapAlignment === 'STAGGERED') {
            angle = baseAngle + (i % 2 === 0 ? 0 : Math.PI);
            // Opposite overrides staggered? Or flips it? Let's flip it.
            if (isOpposite) angle += Math.PI;
        }
        else {
            // ALIGNED, ONE_SIDE, FIXED_SIZE
            if (isOpposite) {
                angle = baseAngle + Math.PI;
            }
        }

        const baseRadiusForRings = config.mode === 'RHYTHMIC_ESCAPE' ? (config.rhythmicEscapeShieldRingRadius || 100) : config.containerRadius;
        
        rings.push({
            id: `ring-${i}-${random.next()}`,
            radius: baseRadiusForRings + (i + 1) * config.escapeRingSpacing,
            angle: angle, 
            hue: (i * (360 / Math.max(config.escapeRingCount, 1))) % 360,
            originalIndex: i
        });
    }
    return rings;
  }
}
